// Service Providers and Facility Management share the same screens and API (/companies),
// told apart by the company `type`.
const PROVIDER_TYPES = {
    seller: {
        type: 'seller',
        basePath: '/companies',
        title: 'Service Providers',
        singular: 'Service Provider',
        addLabel: 'Add New Provider',
    },
    facility: {
        type: 'facility',
        basePath: '/facilities',
        title: 'Facility Management',
        singular: 'Facility',
        addLabel: 'Add New Facility',
    },
};

export const providerType = (type) => PROVIDER_TYPES[type] || PROVIDER_TYPES.seller;
